export default __webpack_public_path__ + "static/media/infographics.03c68cff.jpg";